<template>
  <div class="collab-exp">
    <div class="collab-exp__section">
      <div class="global-h6 collab-exp__title">By accepting this Shrpa Creator Visit, you agree to the following:</div>

      <CollabExpectationsList
        class="collab-exp__thesis-list"
        :requestedLocationCount="props.requestedLocationCount"
        :requestedAdventureCount="props.requestedAdventureCount"
        :customerOwnedAdventures="props.customerOwnedAdventures"
      />

      <NoteWithIcon class="collab-exp__warning" color="gray" size="tiny">
        <template #icon><IconEmbedded name="info-simple_4" :size="17" /></template>
        <template #text>
          <span>
            Upon confirmation, you are committing to complete this Shrpa Creator Visit. Cancellations are highly discouraged and can impact your reputation and cause significant inconvenience for the
            destination you're working with.
          </span>
        </template>
      </NoteWithIcon>
    </div>
    <div class="collab-exp__section">
      <div class="global-h6 collab-exp__title">How can the creator visit content be used?</div>
      <!-- Thesis list -->
      <ul class="thesis-list collab-exp__thesis-list">
        <li class="thesis-list__thesis">The destination may use your photos, videos, and text for their website, social media, or other marketing materials.</li>
        <li class="thesis-list__thesis">Content created for this creator visit can be used by the destination without future payment or licensing fees.</li>
        <li class="thesis-list__thesis">You affirm that content created as part of this creator visit is original and does not infringe on any third-party rights.</li>
      </ul>
      <!-- / Thesis list -->
    </div>

    <div class="collab-exp__section">
      <div class="global-h6 collab-exp__title">Tips for a successful creator visit:</div>
      <!-- Thesis list -->
      <ul class="thesis-list collab-exp__thesis-list">
        <li class="thesis-list__thesis">Take LOTS of photos! You can add descriptions after your trip but you can't create photos after the fact.</li>
        <li class="thesis-list__thesis" v-if="!props.customerOwnedAdventures">You can re-use stops across adventures but vary your descriptions and photos.</li>
        <li class="thesis-list__thesis">Communicate! If you have questions or a change of plans, let both Shrpa and the destination know.</li>
        <li class="thesis-list__thesis"><a target="_blank" :href="globalGetLink('CollabGuidance')">Get more tips</a>.</li>
      </ul>
      <!-- / Thesis list -->
    </div>
    <div class="collab-exp__section" v-if="props.showPaymentPolicy">
      <div class="global-h6 collab-exp__title">Payment Policy</div>
      <!-- Thesis list -->
      <ul class="thesis-list collab-exp__thesis-list">
        <li class="thesis-list__thesis">1st Creator Visit - $300</li>
        <li class="thesis-list__thesis">2nd-4th Creator Visit - $325</li>
        <li class="thesis-list__thesis">5th-7th Creator Visit - $350</li>
        <li class="thesis-list__thesis">8+ Creator Visits - $400</li>
        <!--<li class="thesis-list__thesis">Shrpa will add $250 to your payment to cover lodging if the destination is unable to arrange it.</li> -->
        <li class="thesis-list__thesis">
          Payments from Shrpa are sent via
          <a class="global-a" href="https://www.wingspan.app/" target="_blank">
            Wingspan<!--<IconEmbedded name="external-link_2" :size="17" style="position: relative; top: 3px; left: 2px" color="rgba(0, 0, 0, 0.4)" />-->
          </a>
          after the content is submitted and reviewed.
        </li>
      </ul>
      <!-- / Thesis list -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";

// Components
import CollabExpectationsList from "./CollabExpectationsList.vue";
import NoteWithIcon from "@components/NoteWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const globalGetLink = inject("globalGetLink") as any;

const props = withDefaults(
  defineProps<{
    requestedLocationCount: number;
    requestedAdventureCount: number;
    showPaymentPolicy?: boolean;
    customerOwnedAdventures: boolean;
  }>(),
  {
    requestedLocationCount: 10,
    requestedAdventureCount: 4,
    showPaymentPolicy: true,
    customerOwnedAdventures: false,
  }
);
</script>

<style scoped lang="scss">
// Thesis list ================================================================
.thesis-list {
  padding: 0;
  margin: 0;
  list-style: none;

  &__thesis {
    padding-left: 12px;
    margin-bottom: 5px;
    position: relative;
    color: #5b5b5b;
    font-family: sans-serif;

    &::before {
      content: "";
      width: 6px;
      height: 2px;
      display: block;
      position: absolute;
      inset: 9px auto auto 0;
      font-size: 0;
      line-height: 0;
      background: rgba(0, 0, 0, 0.2);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  :deep(a) {
    color: #2165a6;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }
}

// Collab expectations ========================================================
.collab-exp {
  &__section {
    padding-bottom: 20px;
    margin-bottom: 19px;
    border-bottom: 1px rgba(0, 0, 0, 0.15) solid;

    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
      border-bottom: none;
    }
  }

  &__title {
    margin-bottom: 7px;
  }

  &__thesis-list {
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
